export default "__VITE_ASSET__c696f90f__"